"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
export function useUtmParams() {
  const $ = _c(2);
  let t0;
  bb0: {
    if (typeof window === "undefined") {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      const params = new URLSearchParams(window.location.search);
      t1 = {
        utm_source: params.get("utm_source") ?? undefined,
        utm_medium: params.get("utm_medium") ?? undefined,
        utm_term: params.get("utm_term") ?? undefined,
        utm_content: params.get("utm_content") ?? undefined,
        utm_device: params.get("utm_device") ?? undefined,
        utm_campaign: params.get("utm_campaign") ?? undefined,
        utm_adgroup: params.get("utm_adgroup") ?? undefined,
        utm_location: params.get("utm_location") ?? undefined,
        utm_channel: params.get("utm_channel") ?? undefined,
        utm_variety: params.get("utm_variety") ?? undefined,
        gclid: params.get("gclid") ?? undefined
      };
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    t0 = t1;
  }
  return t0;
}